// extracted by mini-css-extract-plugin
export default {"tag":"CheckableTag_tag__M8T1Q"};